import { createReducer, on } from '@ngrx/store';
import { Leader, LeaderCategory } from '../../core/models/leader.model';
import * as LeadersActions from './leaders.actions';

export interface LeadersState {
  all: Leader[];
  featured: Leader[];
  byCategory: Record<string, Leader[]>;
  selectedLeaderId: string | null;
  bookmarkedIds: string[];
  isLoading: boolean;
  isCacheValid: boolean;
  error: string | null;
  searchQuery: string;
  categoryFilter: LeaderCategory | null;
  lastLoaded: number | null;
}

export const initialLeadersState: LeadersState = {
  all: [],
  featured: [],
  byCategory: {},
  selectedLeaderId: null,
  bookmarkedIds: [],
  isLoading: false,
  isCacheValid: false,
  error: null,
  searchQuery: '',
  categoryFilter: null,
  lastLoaded: null
};

export const leadersReducer = createReducer(
  initialLeadersState,

  on(LeadersActions.loadLeaders, state => ({
    ...state, isLoading: true, error: null
  })),

  on(LeadersActions.loadLeadersSuccess, (state, { leaders }) => ({
    ...state,
    all: leaders,
    isLoading: false,
    isCacheValid: true,
    lastLoaded: Date.now(),
    error: null
  })),

  on(LeadersActions.loadLeadersFailure, (state, { error }) => ({
    ...state, isLoading: false, error
  })),

  on(LeadersActions.loadLeadersByCategorySuccess, (state, { category, leaders }) => ({
    ...state,
    byCategory: { ...state.byCategory, [category]: leaders }
  })),

  on(LeadersActions.loadFeaturedLeadersSuccess, (state, { leaders }) => ({
    ...state, featured: leaders
  })),

  on(LeadersActions.selectLeader, (state, { leaderId }) => ({
    ...state, selectedLeaderId: leaderId
  })),

  on(LeadersActions.clearSelectedLeader, state => ({
    ...state, selectedLeaderId: null
  })),

  on(LeadersActions.setBookmarks, (state, { leaderIds }) => ({
    ...state, bookmarkedIds: leaderIds
  })),

  on(LeadersActions.toggleBookmark, (state, { leaderId }) => {
    const isBookmarked = state.bookmarkedIds.includes(leaderId);
    return {
      ...state,
      bookmarkedIds: isBookmarked
        ? state.bookmarkedIds.filter(id => id !== leaderId)
        : [...state.bookmarkedIds, leaderId]
    };
  }),

  on(LeadersActions.setSearchQuery, (state, { query }) => ({
    ...state, searchQuery: query
  })),

  on(LeadersActions.setCategoryFilter, (state, { category }) => ({
    ...state, categoryFilter: category
  })),

  on(LeadersActions.invalidateCache, state => ({
    ...state, isCacheValid: false
  }))
);
